import { useRouter } from "next/router";

export default function useCollectionPageUrl(fallback = "") {
  const { asPath } = useRouter();

  // TODO: i18n
  return asPath?.includes("collections") ? asPath : fallback;
}
